import React from "react";

export function EroundPrefillHint({ visible }: { visible: boolean }) {
  if (!visible) return null;
  return (
    <small
      data-testid="eround-prefill-hint"
      className="text-color-secondary mb-3 block"
    >
      Auto-filled from eRound (buffered) — edit to override.
    </small>
  );
}
